import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";

// prevent root conflict
const root = ReactDOM.createRoot(document.getElementById("virtualShowroomApp") as HTMLElement);
root.render(<App />);
